import { render, staticRenderFns } from "./PConfirm.vue?vue&type=template&id=0a777e2a&scoped=true"
import script from "./PConfirm.vue?vue&type=script&lang=ts"
export * from "./PConfirm.vue?vue&type=script&lang=ts"
import style0 from "./PConfirm.vue?vue&type=style&index=0&id=0a777e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a777e2a",
  null
  
)

export default component.exports